import React from 'react';
// styles
import styles from './styles.module.scss';
import {
  CheckMark,
  ForwardArrow,
  UserIconFilled,
} from '@/components/landing-page-templates/ConfigLandingPage/LandingPageIcons';

const SuccessfulPasswordSetSection = ({
  currentUserEventPermissions,
  buttonStyle,
  email,
  onPasswordReset
}) => {

  const { backgroundColor, color } = buttonStyle;

  let root = document.documentElement;
  root.addEventListener('mouseover', e => {
    root.style.setProperty('--background', backgroundColor);
    root.style.setProperty('--font-color', color);
  });

  return (
    <>
      <div className={styles.outerSectionContainer}>
        <div className={styles.innerSectionContainer}>
          <CheckMark width={'35'} height={'25'} />
        </div>
      </div>
      <div className={styles.mainHeading}>Password Set!</div>
      <div className={styles.heading}>
        <div className={styles.profileIconContainer}>
          <UserIconFilled />
        </div>
        <div>{email}</div>
      </div>
      <div className={styles.button}>
        <button
          type="submit"
          onClick={() => onPasswordReset()}
          style={buttonStyle}
          className={styles.submitButton}
        >
          {/* Forward Arrow SVG */}
          <ForwardArrow color={buttonStyle.color} />
          <p className={styles.buttonText}>Done</p>
        </button>
      </div>
    </>
  )
}

export default SuccessfulPasswordSetSection;
